import type { QuestionnaireField } from "src/state/QuestionnaireStepCubit/QuestionnaireStepCubit";

/**
 * Resolves the id of the hidden, `[only-logic]` weight question a
 * `[body-metrics-field]` question is paired with via its
 * `[weight-field-ref="<ref>"]` keyword (see BodyMetricsInput). Answers are
 * keyed by field id, but the CMS links fields by their stable `ref`, so this
 * translates one into the other.
 */
export function findPairedWeightFieldId(
  fields: QuestionnaireField[],
  weightFieldRef: string | undefined
): string | undefined {
  if (!weightFieldRef) {
    return undefined;
  }

  return fields.find((field) => field.ref === weightFieldRef)?.id;
}
